import { Icon, ListItemButton, ListItemIcon, Typography } from "@mui/material";

/**
 * Shared navigation row (icon + label) so the account drawer and the discovery
 * sidebar render menu items with one identical style. Remaining props pass to
 * the underlying ListItemButton (e.g. component, to, onClick, data-testid).
 *
 * @param {{ icon: string|React.ReactNode, label: React.ReactNode,
 *   endAdornment?: React.ReactNode, sx?: object }} props icon is a Material
 *   Symbols ligature name or a rendered node.
 */
const NavMenuItem = ({ icon, label, endAdornment, sx, ...buttonProps }) => (
  <ListItemButton
    {...buttonProps}
    sx={{
      borderRadius: "8px",
      py: 0.75,
      px: 1,
      color: "text.primary",
      "&.active": { backgroundColor: "overlay.black06", fontWeight: 600 },
      ...sx,
    }}
  >
    <ListItemIcon sx={{ minWidth: 40, color: "icon.primary" }}>
      {typeof icon === "string" ? (
        <Icon baseClassName="material-symbols-outlined" fontSize="medium">
          {icon}
        </Icon>
      ) : (
        icon
      )}
    </ListItemIcon>
    <Typography variant="h5" sx={{ flex: 1 }}>
      {label}
    </Typography>
    {endAdornment}
  </ListItemButton>
);

export default NavMenuItem;
